import { useState, useEffect, useCallback } from "react";
import { httpRequest } from "@/lib/axios";

export interface UsageSummary {
  copilot: { used: number; limit: number; period: string };
  agents: { used: number; limit: number; period: string };
  automations: { used: number; limit: number; period: string };
  total_monthly: number;
}

export function useCreditUsage() {
  const [data, setData] = useState<UsageSummary | null>(null);
  const [loading, setLoading] = useState(true);

  const fetch = useCallback(async () => {
    try {
      const res = await httpRequest.get("/tenant/usage-summary");
      setData(res.data);
    } catch {
      // silently fail — bar just won't show
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetch();
    const interval = setInterval(fetch, 5 * 60 * 1000); // refresh every 5min
    return () => clearInterval(interval);
  }, [fetch]);

  return { data, loading, refresh: fetch };
}
